exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fg-new-badge[data-v-0cfa6cff]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:20px;padding:0 10px;border-radius:999px;font-size:11px;font-weight:600;line-height:1;background:#e6f6f3;color:#2a9d8f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0cfa6cff","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/franchise_component/faq_guideline/faq-guideline-new-badge.vue
// module id = WRg8
// module chunks = 99